// src/hooks/programs/useGetProgramPdfSections.js
import { useQuery } from "@tanstack/react-query";
import { getProgramPdfSections } from "../../api/apiPrograms";
import i18next from "i18next";

const useGetProgramPdfSections = (id) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["program-pdf-sections", id, i18next.language],
        queryFn: () => getProgramPdfSections(id),
        enabled: !!id,
    });

    return {
        pdfSections: data?.data || null,
        error,
        isLoading,
        refetch,
    };
};

export default useGetProgramPdfSections;
